import notification from 'antd/lib/notification'
import React, { useEffect, useMemo } from 'react'
import Icon from '@ant-design/icons/lib/components/Icon'
import CrossIcon from 'src/assets/icons/red-cross.svg?react'

const Context = React.createContext({ name: 'Default' })

type NotificationPropsType = {
    message: string
    description: string
}

const Notification = (props: NotificationPropsType) => {
    const [api, contextHolder] = notification.useNotification()

    useEffect(() => {
        const { message, description } = props
        const key = crypto.randomUUID()
        api.info({
            key,
            message: message,
            description: <Context.Consumer>{() => description}</Context.Consumer>,
            placement: 'bottomLeft',
            duration: 10,
            icon: <Icon component={CrossIcon} />,
        })
    }, [props, api])

    const contextValue = useMemo(() => ({ name: 'Error Notification' }), [])

    return <Context.Provider value={contextValue}>{contextHolder}</Context.Provider>
}

export default Notification
